import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  VEHICLE_VALUATION_COST_WARRANTY_RESOURCE,
  type VehicleValuationCostWarrantyUpdateBody,
  type VehicleValuationCostWarrantyUpdateResponse,
} from "./vehicle-valuation-cost-warranty.types";

export function useVehicleValuationCostWarrantyUpdateMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    VehicleValuationCostWarrantyUpdateResponse,
    Error,
    VehicleValuationCostWarrantyUpdateBody & { uuid: string }
  >({
    mutationFn: async ({ uuid, ...body }) => {
      const response = await alphartisApiAxios.patch<VehicleValuationCostWarrantyUpdateResponse>(
        `/v1/${VEHICLE_VALUATION_COST_WARRANTY_RESOURCE}/${uuid}`,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_COST_WARRANTY_RESOURCE],
      });
    },
  });
}
